import { Page } from "@/models/page-models/Page";

export const CommercialGroups: Page = {
  "path": "commercial-groups",
  "name": "Groups",
  "props": {
    "data": {
      "title": "Groups",
      "printable": "FALSE",
      "url": "commercial-groups",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Create Supplier Group",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "resetFormData",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getDefaultFormData",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData",
                        "arg3Key": "destinationKeyType",
                        "arg3Value": "Object",
                        "arg4Key": "append",
                        "arg4Value": "TRUE"
                      },
                      "name": "resetFormData"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "openSupplierGroupPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Supplier Group"
                      },
                      "name": "openSupplierGroupPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Supplier Groups",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.supplierGroups.data}}",
                  "items": "fetchedData.supplierGroups.data",
                  "headers": [
                    {
                      "value": "__item._id",
                      "text": "Group Id"
                    },
                    {
                      "value": "__item.name",
                      "text": "Group Name"
                    },
                    {
                      "value": "__item.users",
                      "text": "Users",
                      "multipleItemsVariable": "users",
                      "itemParam": "displayName"
                    },
                    {
                      "value": "__item.actions",
                      "text": "Actions",
                      "type": "actions",
                      "actions": [
                        {
                          "label": "Edit",
                          "priority": "main",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "copyGroupData",
                                "type": "fnCopyData",
                                "arg1Key": "sourceKey",
                                "arg1Value": "__item",
                                "arg2Key": "destinationKey",
                                "arg2Value": "formData",
                                "arg3Key": "destinationKeyType",
                                "arg3Value": "Object",
                                "arg4Key": "append",
                                "arg4Value": "TRUE"
                              },
                              "name": "copyGroupData"
                            },
                            {
                              "executionOrder": 2,
                              "pageFunction": {
                                "name": "openSupplierGroupPopup",
                                "type": "fnOpenPopup",
                                "arg1Key": "popupName",
                                "arg1Value": "Supplier Group"
                              },
                              "name": "openSupplierGroupPopup"
                            }
                          ]
                        },
                        {
                          "label": "Delete",
                          "priority": "main",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "deleteSupplierGroup",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/supplier-groups/{{__item._id}}",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE",
                                "arg4Key": "requestMethod",
                                "arg4Value": "DELETE"
                              },
                              "name": "deleteSupplierGroup"
                            }
                          ]
                        }
                      ],
                      "useMenu": false
                    }
                  ],
                  "tableType": "static",
                  "showActions": true
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "popupGroup",
          "label": "Supplier Group",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.name",
                  "label": "Group Name",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedUser",
                  "label": "Select User",
                  "disabled": "FALSE",
                  "items": "fetchedData.users.data",
                  "itemText": "displayName",
                  "itemValue": "_id"
                },
                {
                  "type": "button",
                  "label": "Add User",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "pushUserToUserArray",
                        "type": "fnPushToArray",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getSelectedUser",
                        "arg2Key": "destinationVariable",
                        "arg2Value": "formData.users"
                      },
                      "name": "pushUserToUserArray"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "resetUserId",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selectedUser"
                      },
                      "name": "resetUserId"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "table",
                  "variable": "formData.users",
                  "label": "Selected Users",
                  "disabled": "FALSE",
                  "items": "fetchedData.users.data",
                  "headers": [
                    {
                      "value": "__item._id",
                      "text": "Id#"
                    },
                    {
                      "value": "__item.displayName",
                      "text": "Name"
                    },
                    {
                      "value": "__item.actions",
                      "text": "Actions",
                      "type": "actions"
                    }
                  ],
                  "tableType": "dynamic",
                  "variableKey": "_id",
                  "itemKey": "_id",
                  "confirmDelete": false,
                  "canDelete": true,
                  "showActions": true
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Create Group",
              "showIf": "fn(CONDITIONAL,{{formData._id}},false,true)",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "createSupplierGroup",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/supplier-groups/null",
                    "arg2Key": "postData",
                    "arg2Value": "formData",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "requestMethod",
                    "arg4Value": "PUT"
                  },
                  "name": "createSupplierGroup"
                }
              ]
            },
            {
              "label": "Update Group",
              "showIf": "{{formData._id}}",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "updateSupplierGroup",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/supplier-groups/{{formData._id}}",
                    "arg2Key": "postData",
                    "arg2Value": "formData",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "requestMethod",
                    "arg4Value": "PUT"
                  },
                  "name": "updateSupplierGroup"
                }
              ]
            }
          ]
        }
      ]
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCommercialUsersList",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/suppliers/assignable-users",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.users"
        },
        "name": "getCommercialUsersList"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getSupplierGroups",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/supplier-groups",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.supplierGroups"
        },
        "name": "getSupplierGroups"
      }
    ],
    "functions": [
      {
        "name": "getSelectedUser",
        "type": "fnFindInArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.users.data",
        "arg2Key": "searchKey",
        "arg2Value": "_id",
        "arg3Key": "searchValue",
        "arg3Value": "fetchedData.selectedUser"
      },
      {
        "name": "getDefaultFormData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "_id": 0,
          "name": "",
          "users": "[]"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "COMMERCIAL_MANAGER",
  "visible": true,
  "routerPriority": 70
}